import { useMutation } from '@tanstack/react-query'

import { DatabasesAPI, ProjectDomainAPI, ProjectInfosAPI } from '@makyoapp/makyo-sdk'

import { mutationKeys } from '@/lib/react-query/mutation-keys'

// This custom hook is used to delete a custom domain. It uses a mutation function from react-query.
// The mutation function makes a request to the ProjectDomainAPI to delete a custom domain.
export const useReqDeleteCustomDomain = () =>
  useMutation({
    mutationKey: [mutationKeys.builder.deleteCustomDomain],
    mutationFn: async ({ projectId, domainId }: { projectId: string; domainId: string }) => {
      await ProjectDomainAPI.ReqDeleteCustomDomain(projectId, domainId)
    },
  })

// useUpdateSettingsMutation is a custom hook that is used to update the settings of a database.
// It utilizes a mutation function from react-query.
// The mutation function makes a request to the DatabasesAPI to update the settings using the provided database ID and languages.
export const useUpdateSettingsMutation = () =>
  useMutation({
    mutationKey: [mutationKeys.builder.updateSettings],
    mutationFn: async ({ dbId, languages }: { dbId: string; languages: string[] }) => {
      await DatabasesAPI.ReqUpdateSettings(dbId, {
        _Languages: languages,
        _DefaultLanguage: '',
      })
    },
  })

// useUpdateAppIconMutation is a custom hook that is used to update the app icon.
// It uses a mutation function from react-query.
// The mutation function makes a request to the ProjectInfosAPI to update the app icon using the provided project ID and emoji.
export const useUpdateAppIconMutation = () =>
  useMutation({
    mutationKey: [mutationKeys.builder.updateAppIcon],
    mutationFn: async ({ projectId, emoji }: { projectId: string; emoji?: string | File | null }) => {
      await ProjectInfosAPI.ReqUpdateAppIcon(projectId, {
        _AppIcon: emoji || null,
      })
    },
  })

export const useAddCustomDomainMutation = () =>
  useMutation({
    mutationKey: [mutationKeys.builder.updateAppIcon],
    mutationFn: async ({ projectId, customDomain }: { projectId: string; customDomain: string }) => {
      const res = await ProjectDomainAPI.ReqAddCustomDomain(projectId, {
        _CustomDomain: customDomain,
      }).then((res) => res)

      return res
    },
  })
